export default "__VITE_ASSET__B3le8gIs__"